var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 467,
    viewBox: "0 0 467 467",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.5 467C362.458 467 467 362.458 467 233.5C467 104.542 362.458 0 233.5 0C104.542 0 0 104.542 0 233.5C0 362.458 104.542 467 233.5 467ZM82.6836 287.54C75.4692 290.959 75.0713 301.148 81.9897 305.29L84.8252 306.987L233.439 306.994L382.054 307L384.944 305.309C391.93 301.22 391.569 290.977 384.317 287.54C382.171 286.523 369.06 286.427 233.5 286.427C97.9404 286.427 84.8286 286.523 82.6836 287.54ZM76.3716 262.01C77.2446 263.48 79.0347 265.254 80.3506 265.954C82.6602 267.181 88.0166 267.225 233.5 267.225C378.984 267.225 384.34 267.181 386.649 265.954C387.965 265.254 389.755 263.48 390.628 262.01C392.066 259.588 392.179 258.763 391.84 253.167C390.645 233.434 379.912 213.979 361.984 199.047C323.69 167.151 259.198 152.563 196.761 161.675C172.563 165.206 154.321 170.696 134.266 180.484C97.8711 198.246 76.9272 224 75.1597 253.167C74.8203 258.763 74.9336 259.588 76.3716 262.01Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDome);
export default __webpack_public_path__ + "static/media/dome.90916afeb1e2464aaa9584b9631116f4.svg";
export { ForwardRef as ReactComponent };